import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Import pages
import Dashboard from './pages/Dashboard';
import PatientView from './pages/PatientView';
import KnowledgeExplorer from './pages/KnowledgeExplorer';
import Documentation from './pages/Documentation';
import LiteratureSentinel from './pages/LiteratureSentinel';
import PracticeAnalytics from './pages/PracticeAnalytics';
import ClinicalTrials from './pages/ClinicalTrials';
import EducationResources from './pages/EducationResources';
import PharmaceuticalPartner from './pages/PharmaceuticalPartner';
import AdminPages from './pages/AdminPages';

// Import styles
import './styles/tailwind.css';

function App() {
  return (
    <Router>
      {/* Toast notification container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/patient/:id" element={<PatientView />} />
        <Route path="/knowledge" element={<KnowledgeExplorer />} />
        <Route path="/documentation" element={<Documentation />} />
        <Route path="/literature" element={<LiteratureSentinel />} />
        <Route path="/analytics" element={<PracticeAnalytics />} />
        <Route path="/trials" element={<ClinicalTrials />} />
        <Route path="/education" element={<EducationResources />} />
        <Route path="/settings" element={<AdminPages />} />
        <Route path="/partner" element={<PharmaceuticalPartner />} />
        <Route path="/notifications" element={<Dashboard />} /> {/* Placeholder route */}
        <Route path="/profile" element={<Dashboard />} /> {/* Placeholder route */}
      </Routes>
    </Router>
  );
}

export default App;